<template>
    <v-row>
        <v-spacer></v-spacer>
        <v-col lg="3" xs="12" class="d-flex justify-center" align-self="center" id="before-column">
            <v-container>
                <v-row>
                    <v-col class="d-flex justify-end pb-0">
                        <span style="visibility: hidden" class="text-caption font-italic mr-2">USD</span><span style="visibility: hidden" class="text-caption">{{ usd(totalBidAmount) }}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="d-flex justify-center pt-0" align-self="center">
                        <number
                                class="text-h1"
                                ref="before-counter"
                                :from="0"
                                :to="bids"
                                :duration="duration"
                                easing="Power4.easeOut" />
                    </v-col>
                </v-row>
                <v-row class="mt-0">
                    <v-col class="d-flex justify-center" align-self="center">
                        <span class="font-italic caption">Bids</span>
                    </v-col>
                </v-row>
            </v-container>
            <v-container class="mx-4">
                <v-row>
                    <v-col class="d-flex justify-end pb-0">
                        <span class="text-caption font-italic mr-2">USD</span><span class="text-caption" :style="{ 'color': color }">{{ usd(averageBid) }}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="d-flex justify-center pt-0" align-self="center">
                        <number
                                :style="{ 'color': color }"
                                class="d-flex text-h1"
                                :class="{ 'mr-6': averageBid > 10 }"
                                ref="after-counter"
                                :from="0"
                                :to="averageBid"
                                :duration="duration"
                                easing="Power4.easeOut" />
                        <span class="d-flex text-h4 ml-2" v-if="averageBid < 10">.</span>
                        <number v-show="averageBid < 10"
                                :style="{ 'color': color }"
                                class="text-h4"
                                ref="after-counter"
                                :from="0"
                                :to="`${averageBid > 1 ? averageBid * 100 - 100 : averageBid * 100}`.slice(0,2)"
                                :duration="duration"
                                easing="Power4.easeOut" />
                    </v-col>
                </v-row>
                <v-row class="mt-0">
                    <v-col class="d-flex justify-center" align-self="center">
                        <span class="font-italic caption text-no-wrap">Average Bid</span>
                    </v-col>
                </v-row>
            </v-container>
            <v-container>
                <v-row>
                    <v-col class="d-flex justify-end pb-0">
                        <span class="text-caption font-italic mr-2">USD</span><span class="text-caption" :style="{ 'color': color }">{{ usd(totalBidAmount) }}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="d-flex justify-center pt-0" align-self="center">
                        <number
                                :style="{ 'color': color }"
                                class="d-flex text-h1"
                                ref="after-counter"
                                :from="0"
                                :to="totalBidAmount"
                                :duration="duration"
                                easing="Power4.easeOut" />
                        <span class="d-flex text-h4" v-if="totalBidAmount < 10">.</span>
                        <number v-show="totalBidAmount < 10"
                                :style="{ 'color': color }"
                                class="text-h4"
                                ref="after-counter"
                                :from="0"
                                :to="`${totalBidAmount > 1 ? totalBidAmount * 100 - 100 : totalBidAmount * 100}`.slice(0,2)"
                                :duration="duration"
                                easing="Power4.easeOut" />
                    </v-col>
                </v-row>
                <v-row class="mt-0">
                    <v-col class="d-flex justify-center" align-self="center">
                        <span class="font-italic caption text-no-wrap">Total Amount</span>
                    </v-col>
                </v-row>
            </v-container>
        </v-col>
        <v-spacer></v-spacer>
    </v-row>
</template>
<style scoped>
</style>
<script>
import Vue from "vue";
import VueNumber from "@667/vue-number-animation";

Vue.use(VueNumber);

export default {
    name: "StatsCounter",
    components: {},
    props: {
        bids: Number,
        averageBid: Number,
        totalBidAmount: Number,
        color: {
            type: String,
            default: "green",
        },
        duration: {
            type: Number,
            default: 3,
        },
    },
    methods: {
        usd(value) {
            return this.lastNearListing
                ? (value * this.lastNearListing.averageUSD).toFixed(2)
                : undefined;
        },
    },
    computed: {
        lastNearListing() {
            return this.$store.state.lastNearListing;
        },
    },
    mounted() {
        this.$backend.getLatestNearListing();
    },
    watch: {
        isLoading() {
            const self = this;
            if (!self.isLoading)
                self.$nextTick(() => {
                    setTimeout(function () {}, 1000);
                });
        },
    },
};
</script>
